import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, FieldWrapper, Form, FormElement } from "@progress/kendo-react-form";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { Label, Error } from "@progress/kendo-react-labels";

const FormInput = (fieldRenderProps) => {
  const { validationMessage, visited, ...others } = fieldRenderProps;
  return (
    <div>
      <Input {...others} />
      {visited && validationMessage && <Error>{validationMessage}</Error>}
    </div>
  );
};

const FormTextArea = (fieldRenderProps) => {
  const {
    validationMessage,
    visited,
    label,
    id,
    valid,
    disabled,
    optional,
    ...others
  } = fieldRenderProps;
  const showValidationMessage = visited && validationMessage;
  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} optional={optional}>
        {label}
      </Label>
      <TextArea
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
        rows={5}
        placeholder={label}
        style={styles.textArea}
      />
      {showValidationMessage && <Error>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

const EditAboutForm = (props) => {
  return <Dialog title={`Edit About`} onClose={props.cancelEdit} className='flo-kendo-dialog'>
    <Form
      onSubmit={props.onSubmit}
      initialValues={props.item}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"}>
            <div className="mb-3" style={styles.formField}>
              <Field name={"description"} component={FormTextArea} label={"Overview"} />
            </div>
            <div className="mb-3" style={styles.formField}>
              <Field name={"website"} component={FormInput} label={"Website"} />
            </div>
            <div className="mb-3" style={styles.formField}>
              <Field name={"phone"} component={FormInput} label={"Phone"} />
            </div>
            <div className="mb-3" style={styles.formField}>
              <Field name={"terms"} component={FormTextArea} label={"Terms and Conditions"} />
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end">
            <button type={"submit"} className="k-button k-primary" style={styles.modalBtn} disabled={!formRenderProps.allowSubmit}>
              {'Save'}
            </button>
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Cancel
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog>;
};

const styles = {
  formElement: {
    width: 600,
  },
  formField: {
    marginTop: 10,
    marginBottom: 25,
  },
  textArea: {
    backgroundColor: 'transparent',
  },
  modalBtn: {
    padding: '10px 15px'
  },
}

export default EditAboutForm;